export default {
  apiURL: 'http://beta-api.tienpd.me'
};



// WEBPACK FOOTER //
// ./src/config.ts